import React, { createContext, useContext, useEffect, useState } from 'react';
import { getToolTypes } from "../libs/db-lib";
import { useUser } from './User';

export interface ToolTypeContextInterface {
  toolTypes: any[] | null;
}

export const ToolTypeContext = createContext<ToolTypeContextInterface | undefined>(undefined);

export const useToolType = () => {
  const context = useContext(ToolTypeContext);

  if (!context) {
    throw new Error('useToolType must be used within ToolTypeProvider!');
  }

  return context;
}

type ToolTypeProviderType = {
  children: JSX.Element;
};

export function ToolTypeProvider({ children }: ToolTypeProviderType) {
  const { user } = useUser();

  const [toolTypes, setToolTypes] = useState<any>(null);

  useEffect(() => {
    const fetchToolTypes = async () => {
      const toolTypesResponse = await getToolTypes();
      if (!toolTypesResponse?.error) {
        setToolTypes(toolTypesResponse.toolManufacturerList);
      } else {
        console.error('Failed to get tool types', toolTypesResponse.error);
      } 
    }

    if (user && ['ADMIN', 'MANAGER'].includes(user.userType)) {
      fetchToolTypes();
    }
  }, [user]);

  const provider = { toolTypes };

  return <ToolTypeContext.Provider value={provider}>{children}</ToolTypeContext.Provider>;
}
